"use client"

export default function Error() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-24 text-center">
      <h1 className="text-2xl font-bold">Something went wrong</h1>
      <p className="text-gray-500">Please try again later.</p>
    </div>
  )
}
